module.controller('debitWithdrawCtrl', ['$scope', '$state', '$http', '$filter', '$window', 'cacheService', 'Transform', 'baseURI', 'OVERLAY', '$rootScope', 'STATES', '$stateParams', 'accountService', 'LimitsService', 'Session', function ($scope, $state, $http, $filter, $window, cacheService, Transform, baseURI, OVERLAY, $rootScope, STATES, $stateParams, accountService, LimitsService, Session) {

    var debitUrl = baseURI + 'consumer-choice/debit';

    $scope.alert = {};
    $scope.alert.alertMessage = 'Sorry, we were unable to process the transfer at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';

    $scope.overlay = OVERLAY['member.home.debit-card-withdrawal'];
    $scope.formData = {};

    $scope.states = STATES;

    $scope.account = accountService.getAccount($stateParams.username);

    $scope.balance = $scope.account.balance;

    $scope.formData.Amount = $scope.balance;

    $scope.lastFourCardNum = '';

    $scope.amountValid = true;

    function formatCurrency(amount) {
        return '$' + parseFloat(amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    var limits = Session.getLimits();
    if (!limits) {
        LimitsService.getLimits().then(function (resp) {
            limits = LimitsService.setLimits(resp.data.Data);

            if (limits && limits['DBT-OUT']) {
                $scope.limitsValue = limits['DBT-OUT'].volume;
            } else {
                $scope.limitsValue = 0;
            }
            $scope.loadLimit = formatCurrency($scope.limitsValue);
        });
    } else {
        if (limits['DBT-OUT']) {
            $scope.limitsValue = limits['DBT-OUT'].volume;
        } else {
            $scope.limitsValue = 0;
        }
        $scope.loadLimit = formatCurrency($scope.limitsValue);
    }

    $scope.updateLastFourCardNum = function() {
        var cardNumber = $scope.formData.CardNumber;
        if (cardNumber && cardNumber.length >= 4) {
            $scope.lastFourCardNum = cardNumber.slice(-4);
        } else {
            $scope.lastFourCardNum = 'N/A';
        }
    };

    var formatExpDate = function(date){
        var formattedExpDate =  date.split('/');
        if(formattedExpDate[1].length == 4){
            return formattedExpDate[0] + formattedExpDate[1];
        } else {
            return formattedExpDate[0] + '20' + formattedExpDate[1];
        }
    };

    // Adds context to the amount messaging
    $scope.formatAmountMessage = function(){
        if ($scope.formData.Amount > $scope.balance){
            $scope.amountValid = false;
            $scope.amountMessage = 'Oops, there\'s not enough on your ' + $scope.brand.commonProgramName + '.' ;
        }
        else if ($scope.balance < 2.00 || $scope.formData.Amount < 2.00){
            $scope.amountValid = false;
            $scope.amountMessage = 'There is a min amount of $2.00 needed to make this withdrawal.' ;
        }
        else if ($scope.limitsValue && ($scope.balance > $scope.limitsValue || $scope.formData.Amount > $scope.limitsValue)) {
            $scope.amountValid = false;
            $scope.amountMessage = 'You have a withdrawal limit of ' + $scope.loadLimit + '.';
        }
        else {
            $scope.amountValid = true;
            $scope.amountMessage = 'ok';
        }
    };

    $scope.attemptSubmission = function (formData){
        $scope.formatAmountMessage();
        $scope.formData.Amount = parseFloat($scope.formData.Amount);

        if(formData.$valid && $scope.amountValid){
            $scope.alert.errorShown = false;
            $state.go('member.home.debit-card-withdrawal.step2');
        } else {
            $scope.alert.errorShown = true;
            $scope.attempted = true;
        }
    };

    // Review and submit
    $scope.processForm = function(formData){
        $scope.loading = true;
        $scope.formData.ExpDate = formatExpDate($scope.formData.ExpDate);
        var data  = Object.assign({}, $scope.formData);
        data.State = $scope.formData.State.key;

        $http({
            method: 'POST',
            url: debitUrl,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            data: Transform.encode(data)
        }).then(function (resp){
            var data = resp.data;

            $scope.loading = false;
            if(data.Success){
                cacheService.clear('subcard');
                $state.go('member.home.debit-card-withdrawal.step3');
                $scope.alert.successShown = true;
                $scope.alert.successMessage = 'You\'ve withdrawn ' + $filter('akimboCurrency')(formData.Amount, '$') + ' to your card ending in x' + $scope.lastFourCardNum + ".";
            } else {
                $scope.invalidRequest = true;
            }
        }).catch(function (error){
            $scope.loading = false;
            $scope.alert.alertShown = true;
        });
    };
}]);
